/** Build VLC test URL (preview only — password visible locally). */
export function buildVlcTestUrl(camera) {
  if (!camera) return "";
  const direct = String(camera.rtspUrl || "").trim();
  if (direct.startsWith("rtsp://")) return direct;

  const ip = String(camera.ipAddress || "").trim();
  if (!ip) return "";
  const user = encodeURIComponent(String(camera.username || "admin").trim());
  const port = Number(camera.rtspPort) || 554;
  const channel = Number(camera.channel) > 0 ? Number(camera.channel) : 1;
  const vendor = String(camera.vendor || "hikvision").toLowerCase();
  const subtype = camera.subtype === 1 || camera.subtype === "1" ? 1 : 0;
  const streamId = channel * 100 + (subtype === 1 ? 2 : 1);

  if (vendor === "hikvision" || vendor === "cpplus" || vendor === "hik") {
    return `rtsp://${user}:YOUR_PASSWORD@${ip}:${port}/Streaming/Channels/${streamId}`;
  }
  return `rtsp://${user}:YOUR_PASSWORD@${ip}:${port}/cam/realmonitor?channel=${channel}&subtype=0`;
}
